import React from 'react'
import { RectangleSkeleton } from '@sainsburys-tech/bolt'

const PayPalMessagingSkeleton = () => {
  return <RectangleSkeleton height={22} width={350} />
}

export default PayPalMessagingSkeleton
